import React from 'react';
import commonStrings from 'resources/commonStrings';
import styles from './ReportHeading.module.css';

function ReportHeading() {
  const headerClasses = `${styles['intro-text']} ${styles['column']} ${styles['width-12']} nwea-ds-v1-typography-body-copy-large`;
  return (
    <p className={headerClasses}>
      {commonStrings.reportHeaderContent}
      <br />
      {commonStrings.reportHeaderContentExt}
    </p>
  );
}

export default ReportHeading;
